import { message } from 'antd'
import { Props } from '.'
import { useImperativeHandle, useReducer, useRef } from 'react'
import { RcFile } from 'antd/lib/upload'
import { useInitOssHook } from '../BatchUpload/hooks'
import reducer, {
  initialState,
  setIsLoadingAction,
  setPreviewModalOptionAction,
  setUploadFileListAction,
} from './reducer'
import OSS from 'ali-oss'
import { UploadFileItem } from '../BatchUpload'
import { validateExcel } from '../../modules/goodsImportModules/ImportProject'

export type SingleUploadRef = {
  reselect: () => void
}
export function useSetupHook(
  props: Props,
  ref: React.ForwardedRef<SingleUploadRef>,
) {
  const { customProps, onChange } = props
  const {
    validateFile = validateExcel,
    onUploadSucceed,
    onDel,
  } = customProps || {}
  const { ossClientRef } = useInitOssHook()
  const [state, dispatch] = useReducer(reducer, initialState)

  const { uploadFileList, previewModalOption } = state
  const uploadButtonRef = useRef<HTMLElement>(null)
  function handleBeforeUpload(file: RcFile) {
    const canUpload = validateFile?.(file) ?? true
    if (canUpload) {
      uploadOss(file)
    }
    return false
  }
  async function uploadOss(file: RcFile) {
    dispatch(setIsLoadingAction(true))

    const newpath =
      `scp/front/temp/${ossClientRef.current?.timestamp}/` +
      file.uid +
      file.name
    let res: OSS.PutObjectResult | undefined
    try {
      res = await ossClientRef.current?.ossClient.put(newpath, file)
    } catch {
      message.error('上传失败')
    }
    if (res?.res.status === 200) {
      const succeedItem: UploadFileItem = {
        uid: file.uid,
        name: file.name,
        size: file.size,
        type: file.type,
        resultType: '上传中',
        originFile: file,
        url: res.url,
      }
      succeedItem.osspath = res.name
      dispatch(setUploadFileListAction([succeedItem]))
      onUploadSucceed?.(succeedItem)
      onChange?.(succeedItem)
    } else {
      message.error('上传失败')
    }
    dispatch(setIsLoadingAction(false))
  }

  const showPreviewModal = () => {
    dispatch(
      setPreviewModalOptionAction({
        fileUrl: decodeURIComponent(uploadFileList[0].url),
        open: true,
      }),
    )
  }
  function handleDelFile() {
    onDel?.(uploadFileList?.[0])
    onChange?.(undefined)
    dispatch(setUploadFileListAction([]))
  }
  const cancelPreviewModal = () => {
    dispatch(
      setPreviewModalOptionAction({
        ...previewModalOption,
        open: false,
      }),
    )
  }
  useImperativeHandle(
    ref,
    () => ({
      reselect() {
        uploadButtonRef.current?.click()
      },
    }),
    [],
  )

  return {
    state,
    uploadButtonRef,
    cancelPreviewModal,
    showPreviewModal,
    handleBeforeUpload,
    handleDelFile,
  }
}
import { message } from 'antd'
import { Props } from '.'
import { useImperativeHandle, useReducer, useRef } from 'react'
import { RcFile } from 'antd/lib/upload'
import { useInitOssHook } from '../BatchUpload/hooks'
import reducer, {
  initialState,
  setIsLoadingAction,
  setPreviewModalOptionAction,
  setUploadFileListAction,
} from './reducer'
import OSS from 'ali-oss'
import { UploadFileItem } from '../BatchUpload'
import { validateExcel } from '../../modules/goodsImportModules/ImportProject'

export type SingleUploadRef = {
  reselect: () => void
}
export function useSetupHook(
  props: Props,
  ref: React.ForwardedRef<SingleUploadRef>,
) {
  const { customProps, onChange } = props
  const {
    validateFile = validateExcel,
    onUploadSucceed,
    onDel,
  } = customProps || {}
  const { ossClientRef } = useInitOssHook()
  const [state, dispatch] = useReducer(reducer, initialState)

  const { uploadFileList, previewModalOption } = state
  const uploadButtonRef = useRef<HTMLElement>(null)
  function handleBeforeUpload(file: RcFile) {
    const canUpload = validateFile?.(file) ?? true
    if (canUpload) {
      uploadOss(file)
    }
    return false
  }
  async function uploadOss(file: RcFile) {
    dispatch(setIsLoadingAction(true))

    const newpath =
      `scp/front/temp/${ossClientRef.current?.timestamp}/` +
      file.uid +
      file.name
    let res: OSS.PutObjectResult | undefined
    try {
      res = await ossClientRef.current?.ossClient.put(newpath, file)
    } catch {
      message.error('上传失败')
    }
    if (res?.res.status === 200) {
      const succeedItem: UploadFileItem = {
        uid: file.uid,
        name: file.name,
        size: file.size,
        type: file.type,
        resultType: '上传中',
        originFile: file,
        url: res.url,
      }
      succeedItem.osspath = res.name
      dispatch(setUploadFileListAction([succeedItem]))
      onUploadSucceed?.(succeedItem)
      onChange?.(succeedItem)
    } else {
      message.error('上传失败')
    }
    dispatch(setIsLoadingAction(false))
  }

  const showPreviewModal = () => {
    dispatch(
      setPreviewModalOptionAction({
        fileUrl: decodeURIComponent(uploadFileList[0].url),
        open: true,
      }),
    )
  }
  function handleDelFile() {
    onDel?.(uploadFileList?.[0])
    onChange?.(undefined)
    dispatch(setUploadFileListAction([]))
  }
  const cancelPreviewModal = () => {
    dispatch(
      setPreviewModalOptionAction({
        ...previewModalOption,
        open: false,
      }),
    )
  }
  useImperativeHandle(
    ref,
    () => ({
      reselect() {
        uploadButtonRef.current?.click()
      },
    }),
    [],
  )

  return {
    state,
    uploadButtonRef,
    cancelPreviewModal,
    showPreviewModal,
    handleBeforeUpload,
    handleDelFile,
  }
}
